import React from 'react';
import { Flex } from '@abyss/web/ui/Flex';
import { Label } from '@abyss/web/ui/Label';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Button } from '@abyss/web/ui/Button';
import { Layout } from '@abyss/web/ui/Layout';
import { Avatar } from '@abyss/web/ui/Avatar';
import { styled } from '@abyss/web/tools/styled';
import { isLeftMenuEnabled } from '@src/config/CrdpConfig';
import { HeaderController } from './Header.Controller';

const HEADER_ICON_SRC = '/images/image%20(10).png?v=20260521';

const TransparentAvatar = styled(Avatar, {
  backgroundColor: 'transparent !important',
});

type HeaderProps = {
  onMobileMenuClick?: () => void;
};

export const Header: React.FC<HeaderProps> = () => {
  const [{ msid, Action }] = HeaderController();
  const leftMenuEnabled = isLeftMenuEnabled();

  return (
    <Flex
      direction="row"
      justify="space-between"
      alignItems="center"
      className="menu-header-container"
      data-testid="header"
      css={{
        backgroundColor: '#fbf9f4',
        position: 'sticky',
        top: '0',
        zIndex: 1300,
        paddingTop: '14px',
        paddingBottom: '14px',
        paddingLeft: '2rem',
        paddingRight: '2rem',
        '@media (max-width: 768px)': {
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '10px',
        },
      }}
    >
      <Layout.Stack space={1}>
        <Layout.Group alignItems="center" space={6}>
          <Label
            size="md"
            fontWeight="bold"
            color="$primary1"
            css={{ fontSize: '42px', lineHeight: 1 }}
          >
            ACM
          </Label>
          <img
            src={HEADER_ICON_SRC}
            alt="ACM icon"
            style={{ width: '44px', height: '44px', objectFit: 'contain' }}
          />
        </Layout.Group>
        <Label size="xs" color="$gray7" fontWeight="normal" css={{ fontSize: '11px' }}>
          Address Clustering Mapping
        </Label>
      </Layout.Stack>

      <Layout.Group alignItems="center" space={10}>
        <Layout.Group alignItems="center" space={6}>
          <IconSymbol icon="person" size={18} color="$primary1" />
          <TransparentAvatar>{String(msid).slice(0, 2).toUpperCase()}</TransparentAvatar>
          <Label size="sm" color="$gray7" fontWeight="semibold">
            {msid}
          </Label>
        </Layout.Group>

        <Button size="$sm" onClick={Action.Logout}>
          <IconSymbol icon="logout" size={16} />
          Logout
        </Button>
      </Layout.Group>
    </Flex>
  );
};
